import { irSubScenesSlice } from "./irSubScenesSlice";
import * as actions from "./irSubScenesActions";
import * as selectors from "./irSubScenesSelectors";

export { actions };
export { selectors };
export default irSubScenesSlice.reducer;
